import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { analyticsApi } from '../services/analytics';
import { logout } from './authSlice';

// Получить отчет по вакансии
export const fetchVacancyReport = createAsyncThunk(
    'analytics/fetchVacancyReport',
    async ({ vacancyId, asOfDate = null }, { rejectWithValue }) => {
        try {
            return await analyticsApi.getVacancyReport(vacancyId, asOfDate);
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

// Экспортировать отчет по вакансии в Excel
export const exportVacancyReportToExcel = createAsyncThunk(
    'analytics/exportVacancyReportToExcel',
    async (vacancyId, { rejectWithValue }) => {
        try {
            return await analyticsApi.exportVacancyReportToExcel(vacancyId);
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

// Получить отчет по рекрутеру
export const fetchRecruiterReport = createAsyncThunk(
    'analytics/fetchRecruiterReport',
    async (params, { rejectWithValue }) => {
        try {
            // params: { period_start, period_end, org_ids, department_ids, recruiter_ids }
            return await analyticsApi.getRecruiterReport(params);
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

// Экспортировать отчет по рекрутеру в Excel
export const exportRecruiterReportToExcel = createAsyncThunk(
    'analytics/exportRecruiterReportToExcel',
    async (params, { rejectWithValue }) => {
        try {
            return await analyticsApi.exportRecruiterReportToExcel(params);
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

const initialState = {
    vacancyReport: null,
    recruiterReport: null,
    isLoading: false,
    isExporting: false,
    error: null
};

const analyticsSlice = createSlice({
    name: 'analytics',
    initialState,
    reducers: {
        clearVacancyReport: (state) => {
            state.vacancyReport = null;
            state.error = null;
        },
        clearRecruiterReport: (state) => {
            state.recruiterReport = null;
            state.error = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch vacancy report
            .addCase(fetchVacancyReport.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchVacancyReport.fulfilled, (state, action) => {
                state.vacancyReport = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchVacancyReport.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            // Export vacancy report to Excel
            .addCase(exportVacancyReportToExcel.pending, (state) => {
                state.isExporting = true;
                state.error = null;
            })
            .addCase(exportVacancyReportToExcel.fulfilled, (state) => {
                state.isExporting = false;
            })
            .addCase(exportVacancyReportToExcel.rejected, (state, action) => {
                state.isExporting = false;
                state.error = action.payload;
            })

            // Fetch recruiter report
            .addCase(fetchRecruiterReport.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchRecruiterReport.fulfilled, (state, action) => {
                state.recruiterReport = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchRecruiterReport.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            // Export recruiter report to Excel
            .addCase(exportRecruiterReportToExcel.pending, (state) => {
                state.isExporting = true;
                state.error = null;
            })
            .addCase(exportRecruiterReportToExcel.fulfilled, (state) => {
                state.isExporting = false;
            })
            .addCase(exportRecruiterReportToExcel.rejected, (state, action) => {
                state.isExporting = false;
                state.error = action.payload;
            })

            // Logout
            .addCase(logout, () => initialState);
    }
});

export const { clearVacancyReport, clearRecruiterReport, clearError } = analyticsSlice.actions;
export const analyticsReducer = analyticsSlice.reducer;

